import React from 'react';
import { X, Check } from 'lucide-react';
import { useSocialChallenge } from '../../contexts/SocialChallengeContext';
import KSButton from '../common/KSButton';

export default function IncomingChallengeModal() {
  const { incomingChallenge, acceptChallenge, declineChallenge } = useSocialChallenge();

  if (!incomingChallenge) return null;

  const challenger = incomingChallenge.fromUser || { username: 'Challenger', rating: 1500 };

  const handleAccept = () => {
    acceptChallenge(incomingChallenge.id);
  };

  const handleDecline = () => {
    declineChallenge(incomingChallenge.id);
  };

  const challengerAvatar = challenger.profile_image_url || challenger.avatar;

  return (
    <div className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-[100000] animate-slide-in-right pointer-events-auto">
      <div className="relative flex items-center bg-[#363431] text-white rounded-lg shadow-2xl border-2 border-[#4a4743] min-w-[360px] sm:min-w-[440px] max-w-[500px] min-h-[92px] sm:min-h-[100px] h-auto overflow-visible">
        {/* Floating Top-Right Close Button */}
        <button
          onClick={handleDecline}
          className="absolute -top-3 -right-3 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-[#211f1e] hover:bg-[#2c2a28] text-stone-400 hover:text-white flex items-center justify-center border-2 border-[#4a4743] shadow-lg cursor-pointer z-20 transition-all hover:scale-110 active:scale-95"
          aria-label="Close notification"
        >
          <X size={16} className="stroke-[2.5]" />
        </button>

        {/* Left Profile / Pawn Avatar Box */}
        <div className="w-20 sm:w-24 self-stretch bg-[#dfdfdf] flex items-center justify-center shrink-0 rounded-l-lg overflow-hidden border-r-2 border-[#4a4743]">
          {challengerAvatar ? (
            <img src={challengerAvatar} alt={challenger.username} className="w-full h-full object-cover" />
          ) : (
            <svg viewBox="0 0 45 45" className="w-12 h-12 sm:w-14 sm:h-14 text-[#555] fill-current drop-shadow-sm">
              <path d="M 22.5,9 C 20.01,9 18,11.01 18,13.5 C 18,14.78 18.54,15.93 19.41,16.74 C 18.28,17.43 17.5,18.66 17.5,20.08 C 17.5,20.74 17.67,21.36 17.96,21.91 C 15.93,22.61 14.5,24.52 14.5,26.77 C 14.5,27.18 14.55,27.57 14.65,27.95 C 13.08,28.66 12,30.23 12,32.08 L 12,34 L 33,34 L 33,32.08 C 33,30.23 31.92,28.66 30.35,27.95 C 30.45,27.57 30.5,27.18 30.5,26.77 C 30.5,24.52 29.07,22.61 27.04,21.91 C 27.33,21.36 27.5,20.74 27.5,20.08 C 27.5,18.66 26.72,17.43 25.59,16.74 C 26.46,15.93 27,14.78 27,13.5 C 27,11.01 24.99,9 22.5,9 z" />
            </svg>
          )}
        </div>

        {/* Middle Text - Wrapped multi-line if long */}
        <div className="px-4 sm:px-5 flex-1 min-w-0 flex flex-col justify-center py-2.5">
          <span className="font-bold text-base sm:text-lg text-white leading-snug break-words whitespace-normal">
            {challenger.username}
          </span>
          <span className="text-xs sm:text-sm text-stone-300 font-medium mt-1 break-words whitespace-normal flex items-center gap-1.5 flex-wrap">
            <span>🚀 {incomingChallenge.minutes || 1} min · Challenge</span>
            {(incomingChallenge.fen || incomingChallenge.customPosition) && (
              <span className="text-[11px] font-bold text-amber-400 bg-amber-500/20 px-1.5 py-0.5 rounded border border-amber-500/30">
                Custom Setup
              </span>
            )}
          </span>
        </div>

        {/* Action Buttons: Reject & Accept using KSButton */}
        <div className="flex items-center gap-2.5 pr-3.5 sm:pr-4 shrink-0">
          {/* Reject Button (Dark Grey) */}
          <KSButton
            color="stone"
            textColor="#e7e5e4"
            width="auto"
            height="52px"
            onClick={handleDecline}
            title="Decline Challenge"
            className="px-3.5 sm:px-4 text-sm"
          >
            <X size={22} className="stroke-[2.5]" />
          </KSButton>

          {/* Accept Button (Knight Steps Yellow) */}
          <KSButton
            color="yellow"
            textColor="#1c1917"
            width="auto"
            height="52px"
            onClick={handleAccept}
            title="Accept Challenge"
            className="px-3.5 sm:px-4 font-black text-sm"
          >
            <Check size={22} className="stroke-[3]" />
          </KSButton>
        </div>
      </div>
    </div>
  );
}


